import * as R from 'ramda'
import axios from 'axios'
import sys from './globalFunction'
import { serverUrl, serverPrefixUrl } from '../config'
import FormData from 'form-data'
import { setSessionStartDt } from '../context/globalContext'

/**
 * undefined 값 초기값으로 변환
 */
export const nullCheckParameter = params => {
    for (const key in params) {
        if (params[key] === 'Invalid Date') {
            params[key] == ''
        } else if (params[key] instanceof Array) {
            params[key] = params[key] || []
        } else if (typeof params[key] === 'object') {
            params[key] ? nullCheckParameter(params[key]) : {}
        } else {
            switch (typeof params[key]) {
                case 'number':
                    params[key] = params[key] || ''
                    break
                case 'undefined':
                    params[key] = params[key] || ''
                    break
                case 'boolean':
                    params[key] = params[key] || false
                    break
                case 'string':
                    params[key] = params[key] || ''
                    break
                default:
                    params[key] = params[key] || ''
            }
        }
    }
    return params
}

/**
 * undefined 값 파라미터에서 제거
 */
export const nullExceptParameter = params => {
    for (const key in params) {
        if (params[key] instanceof Array && params[key].length === 0) {
            delete params[key]
        } else if ((!params[key] && params[key] !== 0) || params[key] === 'undefined' || params[key] === 'Invalid Date') {
            delete params[key]
        }
    }
    return params
}

export default (query, params, errorHandler = sys.alertErrors) => {
    const makeParameter = () => {
        const method = 'post'
        const url = `${serverUrl}${serverPrefixUrl}${query}`
        const data = new FormData()
        for (const key in params) {
            data.append(key, params[key])
        }
        const headers = {
            'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: '*/*',
            withCredentials : true
        }
        return { method, url, headers, data }
    }

    const defaultCatchHandler = err => {
        const checkStatus = err => R.path(['response', 'status'])(err)
        const dispStatusError = ({ response: { status, statusText } }) =>
            errorHandler([`status:${status}`, statusText])
        const checkMessage = err => R.identity(err.message)
        const dispErrorMessage = () => errorHandler(err.message)
        const checkCustomError = err => err.pass
        const dispError = () => errorHandler(err.toString())
        const checkNetworkErr = err => err.message === 'Network Error'
        const serverNotConnectd = () => errorHandler(['서버에 연결할 수 없습니다.'])
        const run = R.pipe(
            R.cond([
                [checkNetworkErr, serverNotConnectd],
                [checkStatus, dispStatusError],
                [checkMessage, dispErrorMessage],
                [checkCustomError, () => { }],
                [R.T, dispError],
            ]),
            sys.loadingForceEnd
        )
        run(err)
    }

    const exitFn = () => {
        const err = new Error()
        err.pass = true
        throw err
    }
    const errorHandlerWithExit = R.pipe(errorHandler, exitFn)

    const makeResult = response =>
        R.pipe(
            R.path(['data', 'success']),
            R.cond([
                // [R.isNil, () => errorHandlerWithExit(['json data를 얻을 수없습니다.'])],
                // [R.isNil, () => errorHandlerWithExit(console.log("json data를 얻을 수없습니다."))],
                [R.T, () => response.data.data],
                [R.F, response => errorHandlerWithExit(response.data.message)],
            ])
        )(response)

    const run = R.pipe(
        sys.loadingStart,
        makeParameter,
        axios,
        R.andThen(makeResult),
        R.andThen(R.tap(R.pipe(sys.loadingEnd, setSessionStartDt)))
    )
    const catchFn = R.pipe(R.tap(sys.loadingForceEnd), R.tap(defaultCatchHandler), Promise.reject)

    return typeof window !== 'undefined' ? run().catch(catchFn) : Promise.resolve({})
}
